export const environment = {
  production: false,
  name: 'dev',
  apiBaseUrl: 'https://devtogo.clinicalenrollment.com/api/v1',
  socketUrl: 'https://devtogo.clinicalenrollment.com',
  otpExpirySeconds: 120,
  screenIdleTimeoutMinutes: 30,
  maxFacilities: 5,
  perPageRecords: 10,
  assets: {
    defaultUserAvatar: '/images/default.jpg'
  },
  cometChat: {
    appID: "16754643e352bb53b", // team arkenea account(manoj)
    region: "us",
    authKey: "82972d39a6e137b147f5f7d42c4dfbc868d93981"
  },
  perPageLimit: 10,
  pageSizeOptions:[10, 25, 50]
};